import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const visitorId = () => {
  let id = localStorage.getItem("vid");
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, "");
    localStorage.setItem("vid", id);
  }
  return id;
};

// Statistiques anonymes, une fois par session et par type d'événement. Les visites de l'admin ne sont pas comptées.
export const track = (event) => {
  try {
    if (!BACKEND || localStorage.getItem("noTrack") === "1") return;
    const key = `tracked-${event}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    const lang = localStorage.getItem("lang") === "en" ? "en" : "fr";
    axios.post(`${BACKEND}/api/track`, { event, vid: visitorId(), lang }).catch(() => {});
  } catch {
    /* stockage indisponible : on ne compte pas */
  }
};
